import _ from 'lodash'

/**
 * Returns a function that will apply necessary properties onto filters that
 * were created by a drilldown action. The function returned by this should be
 * reused for all filters created by the drilldown, so that they have the same
 * drilldownActionId
 *
 * @param {WidgetView} [widgetView] - the WidgetView that we're applying the
 * drilldown to (eg a ChartWidgetView or DatasetTableWidgetView). Note that
 * this will be null when not on a dashboard
 *
 * @param {String} [drilldownActionId] the drilldownActionId to use if the
 * drilldown was already performed by another widget. For example, if there
 * was a drilldown on a map widget, and we're applying that to a dataset table
 * widget, there will be a drilldownActionId produced by the map drilldown to
 * apply to the table widget filters. No drilldownActionId should be provided
 * if this is the "initial" drilldown action; one will be generated.
 */
function applyDrilldownActionFactory ({ widgetView, drilldownActionId }) {
	drilldownActionId = drilldownActionId ?? _.uniqueId()

	return f => {
		// #18610 generate a unique drilldownActionId we can use to keep track of
		// manual filters that had a drilldown applied
		f.drilldownActionId = drilldownActionId

		if (widgetView && _.isNil(f.linkGroup)) {
			// Set the linkGroup for the drillown filter to be the widget's ID, because
			// that will guarantee uniqueness and consistency (so drawer filters can
			// be put in the same linkGroup)
			f.linkGroup = widgetView.model.wob.id
		}

		if (_.isNil(f.cid)) {
			// Add a prefix to make it unique and avoid conflict with cid
			// generated in datasets-filter-layout.js ('t' is what we used when
			// this was limited to use by dataset tables; keeping it just in
			// case something depends on it being 't')
			f.cid = _.uniqueId('t')
		}
	}
}

export default applyDrilldownActionFactory

applyDrilldownActionFactory.__filename__ = 'dashboards/widgets/apply-drilldown-action-factory.js'
